import React from "react";
import { GlobalApplicationState } from "globalApplicationState";
import { ConnectedProps, connect } from "react-redux";
import TopicViewDetails from "./topicViewDetails";
import { TopicDetails } from "modules/topics";
import { tagsApi } from "api/instances";
import TopicMove from "../topicMove";
import TopicEdit from "../topicEdit";

const TopicViewDetailsWithActions: React.FunctionComponent<PropsWithRedux> = (props) => {
    const [topicDetails, setTopicDetails] = React.useState<TopicDetails | undefined>(props.topicDetails);

    const [moveDialogOn, setMoveDialogOn] = React.useState(false);

    const [editDialogOn, setEditDialogOn] = React.useState(false);

    const openMoveDialog = () => setMoveDialogOn(true);

    const closeMoveDialog = () => setMoveDialogOn(false);

    const openEditDialog = () => setEditDialogOn(true);

    const closeEditDialog = () => setEditDialogOn(false);

    React.useEffect(() => {
        const getTopicDetails = async () => {
            const parseAudiences = (audienceIds: string[]) => {
                return props.audiences.filter(a => audienceIds.includes(a.id))
                    ?.map(a => ({ id: a.id, name: a.displayName }));
            };

            const details = await tagsApi.getTopicById(props.topicId);
            const cleanedDetails = {
                id: props.topicId,
                name: details.name,
                groupId: details.group,
                disabled: details.disabled,
                default: details.default,
                mandatory: details.mandatory,
                restricted: details.restricted,
                defaultFor: parseAudiences(details.defaultFor),
                mandatoryFor: parseAudiences(details.mandatoryFor),
                restrictedTo: parseAudiences(details.restrictedTo)
            };
            setTopicDetails(cleanedDetails);
        };

        if (!props.topicDetails) getTopicDetails();
    }, [props.topicId, props.audiences, props.topicDetails]);

    return (
        <React.Fragment>
            {
                topicDetails &&
                <TopicEdit
                    topic={topicDetails}
                    show={editDialogOn}
                    onClose={closeEditDialog}
                />
            }

            {
                <TopicMove
                    toMove={`Move topic`}
                    topics={[props.topicId]}
                    show={moveDialogOn}
                    onClose={closeMoveDialog}
                />
            }

            {
                <TopicViewDetails
                    topic={topicDetails}
                    show={props.onShow}
                    onClose={props.closeDetailsDialog}
                    onEdit={openEditDialog}
                    onMove={openMoveDialog}
                />
            }
        </React.Fragment>
    );
};

interface ComponentProps {
    topicId: string;
    onShow: boolean;
    topicDetails?: TopicDetails;
    closeDetailsDialog: () => void;
}

const connector = connect(
    (state: GlobalApplicationState, ownProps: ComponentProps) => ({
        ...ownProps,
        audiences: state.audiences.audiences
    })
);

type PropsWithRedux = ConnectedProps<typeof connector>;

export default connector(TopicViewDetailsWithActions);